<template>
  
<div>
  <!-- Add Task Modal -->
  <b-modal ref="kanbanAddTaskModal" v-model="showTaskModal" title="Add New Task" body-class="bg-white mb-0">
    <b-form>
      <b-form-group label="Task Name">
        <b-form-input v-model="newTask.name" required placeholder="Enter task title"></b-form-input>
      </b-form-group>

      <b-form-group label="Task Details">
        <b-form-textarea v-model="newTask.details" placeholder="Enter task details (optional)" rows="3"></b-form-textarea>
      </b-form-group>

      <b-form-group label="Tags">
        <multiselect v-model="newTask.tags" :options="[]" track-by="name" :multiple="true" :taggable="true"
          tag-placeholder="Add this as new tag" placeholder="Search or Add Tags" @tag="addTag" label="name"
          :close-on-select="true" :clear-on-select="false" :preserve-search="false" :preselect-first="false"
          :hide-selected="true" aria-placeholder="Select a Tag">
        </multiselect>
      </b-form-group>

      <b-form-group label="Type">
        <b-form-input v-model="newTask.type" placeholder="Enter task type (optional)"></b-form-input>
      </b-form-group>
    </b-form>

    <div slot="modal-footer" class="w-100">
      <b-button variant="success" size="sm" class="float-right" @click="handleAddTask(task)">Add Task</b-button>
      <b-button variant="danger" size="sm" class="float-right mr-3" @click="hideModal('kanbanAddTaskModal')">Cancel</b-button>          
    </div>
  </b-modal>

  <!-- Edit Task Modal -->
  <b-modal v-if="task" ref="kanbanEditTaskModal" v-model="isEditTaskModalVisible" title="Edit Task" body-class="bg-white mb-0">
    <b-form>
      <b-form-group label="Task Name">
        <b-form-input v-model="task.name" required placeholder="Enter task title"></b-form-input>
      </b-form-group>

      <b-form-group label="Task Details">
        <b-form-textarea v-model="task.details" placeholder="Enter task details (optional)" rows="3"></b-form-textarea>
      </b-form-group>

      <b-form-group label="Tags">
        <multiselect v-model="task.tags" :options="[]" track-by="name" :multiple="true" :taggable="true"
          tag-placeholder="Add this as new tag" placeholder="Search or Add Tags" @tag="addTag" label="name"
          :close-on-select="true" :clear-on-select="false" :preserve-search="false" :preselect-first="false"
          :hide-selected="true" aria-placeholder="Select a Tag">
        </multiselect>
      </b-form-group>

      <b-form-group label="Type">
        <b-form-input v-model="task.type" placeholder="Enter task type (optional)"></b-form-input>
      </b-form-group>
    </b-form>

    <div slot="modal-footer" class="w-100">
      <b-button variant="success" size="sm" class="float-right" @click="handleEditTask(task)">Save Changes</b-button>
      <b-button variant="danger" size="sm" class="float-right mr-3" @click="hideModal('kanbanEditTaskModal')">Cancel</b-button>          
    </div>
  </b-modal>
  </div>
</template>

<script>
  import Multiselect from "vue-multiselect";
  import moment from 'moment-timezone';

  export default {
    name: 'KanbanModal',
    components: {},
    props: ['task'],
    data() {
      return {
        showTaskModal: false,
        isEditTaskModalVisible: false,
        selectedColumnIdx: 0,      
        newTask: {
          name: '',
          details: '',
          tags: [],
          type: '',
          date: '',
          column: ''
        }        
      }
    },

    methods: {

      showModal(ref) {
        this.$refs[ref].show()
      },

      hideModal(ref) {
        this.$refs[ref].hide()
      },

      addTag(newTag) {
        const tag = {
          name: newTag,
        };

        let existsIndex = this.newTask.tags.findIndex(t => t.name === newTag);
        if (existsIndex === -1)
          this.newTask.tags.push(tag);
      },

      async handleAddTask() {
        if (!this.newTask.name) {
          this.$toast.error("Missing Task Name. Please try again");
          return false;
        }

        try {
          // Prepare the payload to add the task
          const payload = {
            boardId: this.currentBoard.id,
            columnId: this.selectedColumn.id,
            task: {
              id: Date.now().toString(),
              ...this.newTask
            }
          };

          // Dispatch the add task action
          await this.addTask(payload);

          // Reset the new task data
          this.newTask = {
            name: '',
            tags: [],
            date: new Date()
          };

          // Close the modal
          this.showTaskModal = false;

        } catch (error) {
          this.$toast.error("Error adding task. Please try again.");
          this.$toast.error("Error adding task. Please try again.");
        }
      },

      async handleEditTask() {
        if (!this.task.name) {
          this.$toast.error("Missing Task Name. Please try again");
          return false;
        }

        try {
          // Update the task in the current board
          const updatedColumns = [...this.currentBoard.columns];
          updatedColumns[this.editColumnIndex].tasks[this.taskIndex] = this.task;

          // Prepare the payload to update the board
          const payload = {
            boardId: this.currentBoard.id,
            updates: {
              columns: updatedColumns,
              lastModified: new Date(),
              lastModifiedBy: this.userID
            }
          };

          // Dispatch the update action
          await this.$store.dispatch('kanban/updateBoard', payload);

          // Reset the edit task data
          this.task = {
            name: '',
            details: '',
            tags: [],
            type: '',
            date: new Date()
          };

          // Close the modal
          

        } catch (error) {
          this.$toast.error("Error adding task. Please try again.");
          this.$toast.error("Error updating task. Please try again.");
        }
      },
    }
    
  }
</script>
